import router from '@/router'
import {
  auth,
  db,
  Timestamp
} from "../api"; //import all foder api
export const actions = {
  signup({
    commit
  }, payload) {
    commit('setLoading', true)
    auth.createUserWithEmailAndPassword(payload.email, payload.password)
      .then(firebaseUser => {
        commit('setUser', firebaseUser.user)
        commit('setUid', firebaseUser.user.uid)
        commit('setError', false)
        commit('setLoading', false)
        router.push('/main')
      })
      .catch(error => {
        commit('setError', true)
        commit('setLoading', false)
      })
  },
  forgot({
    commit
  }, payload) {
    commit('setLoading', true)
    auth.sendPasswordResetEmail(payload.email)
      .then(firebaseUser => {
        commit('setError', false)
        commit('setLoading', false)
        commit('setSuccess', true)
      })
      .catch(error => {
        commit('setError', true)
        commit('setLoading', false)
      })
  },
  login({
    commit
  }, payload) {
    commit('setLoading', true)

    auth.signInWithEmailAndPassword(payload.email, payload.password)
      .then(res => {
        res = res.user
        commit('setUser', res.displayName ? res.displayName : res.email)
        commit('setUid', res.uid)
        commit('setEmail', res.email)
        commit('setLoading', false)
        commit('setError', false)
        commit('setEmail', payload.email)
        router.push('/main')
      })
      .catch(error => {
        commit('setError', true)
        commit('setLoading', false)
      })
  },
  autoSignIn({
    commit,
    dispatch
  }, payload) {
    if (payload) {
      commit('setUser', payload.displayName ? payload.displayName : payload.email)
      commit('setUid', payload.uid)
      commit('setEmail', payload.email)
      dispatch('getData', payload.uid)
    }
  },
  userSignOut({
    commit
  }) {
    auth.signOut()
    commit('setUser', null)
    router.push('/login')
  },
  getInsureCompany({
    commit
  }) {
    const data = []
    db.collection("insure_company").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id;
          data.push(item)
        })
        commit('setInsureCompany', data)
      })
    // .catch(err => console.log(err))
  },
  regisData({
    commit
  }, payload) {
    commit('setLoading', true)
    payload.created = Timestamp.fromDate(new Date())
    db.collection("members").add(payload).then(function (docRef) {
      commit('setRegisId', docRef.id)
      commit('setLoading', false)
      commit('setSuccess', true)
    })
  },
  saveData({
    commit
  }, payload) {
    commit('setLoading', true)
    payload.updated = Timestamp.fromDate(new Date())
    db.collection("members").doc(payload.id).update(payload).then(function () {
      commit('setUserData', payload)
      commit('setLoading', false)
      commit('setSuccess', true)
    })
  },
  getData({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").where('site', '==', 'srikrung.brokertg.com')
      .where('uid', '==', payload)
      .where('uid', '>', '')
      .get()
      .then(snapshot => {
        if (!snapshot.empty) {
          const data = snapshot.docs[0].data()
          commit('setRegisId', snapshot.docs[0].id)
          if (data.affiliate) {
            db.collection("members").where('site', '==', 'srikrung.brokertg.com')
              .where('uid', '==', data.affiliate).get()
              .then(snapshot => {
                if (!snapshot.empty) {
                  const affiliate = snapshot.docs[0].data()
                  data.affName = affiliate.fullName
                  data.affLevel = affiliate.level
                  data.affNumber = affiliate.license
                  data.affMobile = affiliate.mobile
                  commit('setUserData', data)
                }
                commit('setLoading', false)
              })
          } else {
            commit('setUserData', data)
            commit('setLoading', false)
          }
        } else {
          commit('setLoading', false)
        }
      })
  },
  getAffiliate({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").where('site', '==', 'srikrung.brokertg.com')
      .where('uid', '==', payload).get()
      .then(snapshot => {
        if (!snapshot.empty) {
          commit('setAffiliate', snapshot.docs[0].data())
        }
        commit('setLoading', false)
      })
  },
  getDataById({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").doc(payload).get()
      .then(snapshot => {
        if (snapshot.id) {
          commit('setRegisId', snapshot.id)
          let data = snapshot.data()
          if (data.affiliate) {
            db.collection("members").where('site', '==', 'srikrung.brokertg.com')
              .where('uid', '==', data.affiliate).get()
              .then(snapshot => {
                if (!snapshot.empty) {
                  const affiliate = snapshot.docs[0].data()
                  data.affName = affiliate.fullName
                  data.affNumber = affiliate.license
                  data.affLevel = affiliate.level
                  data.affMobile = affiliate.mobile
                  data.affLine = affiliate.line
                  data.affEmail = affiliate.email
                  commit('setUserData', data)
                }
                commit('setLoading', false)
              })
          } else {
            commit('setUserData', data)
            commit('setLoading', false)
          }
        } else {
          commit('setLoading', false)
        }
      })
  },
  getAgents({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").where('site', '==', payload.site).where('affiliate', '==', payload.uid).get()
      .then(snapshot => {
        let data = null
        if (!snapshot.empty) {
          data = []
          snapshot.forEach(doc => {
            let item = doc.data()
            item.id = doc.id;
            data.push(item)
          })
        }
        console.log(data)
        commit('setAgents', data)
        commit('setLoading', false)
      })
  },
  logout({
    commit
  }) {
    auth.signOut()
    // localStorage.clear()
    commit('setUser', null)
    router.push('/login')
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js